




























































































































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import PermitVariables from '@/Permit/PermitVariables';
import BuildEntityComponent from '@/Shared/CommonEntityMixins/EntityComponentMixin';
import RadioToggle from '@/Shared/RadioToggle.vue';

const component = mixins(LocationBasedMixin, BuildEntityComponent<PermitVariables>()).extend({
    components: {
        RadioToggle
    },
    data() {
        return {
            i18nPrefix: 'admin.permitManagement.permitSettings',
            startDate: null as Date | null,
        };
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/permits/variables`;
        },
    },
    methods: {
        async saveSettings() {
            this.saveEntity();
            const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.saveSuccessTitle`);
            const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.saveSuccessMessage`);
            this.$bvToast.toast(translatedMessage.toString(), {
                title: translatedTitle.toString(),
                autoHideDelay: 5000
            });
        },
    }
});

export default component;

